var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 24,
    viewBox: "0 0 42 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83881 0.952121L12.5888 0.952121L12.5946 0.946325H21.695L9.50428 13.1371C8.64663 13.9947 8.47787 14.7293 8.48999 15.2279C8.50352 15.7848 8.75301 16.3688 9.21921 16.835C9.68542 17.3013 10.2693 17.5508 10.8261 17.5644C11.3245 17.5766 12.0587 17.408 12.9159 16.5508L26.5671 2.89958C28.5538 0.912819 30.9479 -0.0563581 33.3646 0.00253011C35.723 0.0599972 37.8407 1.09043 39.3651 2.61507C40.8895 4.13969 41.9195 6.25755 41.9768 8.61568C42.0356 11.0321 41.0668 13.4261 39.0802 15.4127L31.3643 23.1286H22.2638L34.53 10.8625C35.3871 10.0053 35.5559 9.27092 35.5438 8.77223C35.5302 8.21522 35.2807 7.63115 34.8145 7.16488C34.3483 6.69862 33.7645 6.44917 33.2078 6.43561C32.7095 6.42346 31.975 6.59209 31.1173 7.4498L17.4661 21.101C15.4795 23.0876 13.0855 24.0565 10.669 23.9975C8.31085 23.9399 6.19313 22.9096 4.66873 21.385C3.14432 19.8604 2.11421 17.7425 2.0569 15.3842C1.99818 12.9676 2.96732 10.5736 4.95405 8.58683L7.76252 5.77836L0 5.77836L4.83881 0.952121Z",
    fill: "url(#paint0_linear_165_28988)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_165_28988",
    x1: 41.9794,
    y1: 22.6701,
    x2: 1.08818,
    y2: 22.4751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3495FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446418,
    stopColor: "#5C44EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5DEE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/small-logo.2f5e002f.svg";
export { ForwardRef as ReactComponent };